import { DEBIT_SIGN_UP_CONFIRM_ADDRESS } from 'stash/actions/debitSignUpTrackingEvents';

const debitSignUpReducer = (state = {}, action) => {
	switch (action.type) {
		case DEBIT_SIGN_UP_CONFIRM_ADDRESS: {
			return {
				...state,
				address: action.address,
			};
		}

		default:
			return state;
	}
};

export default debitSignUpReducer;
